import { AfterViewInit, Component, ElementRef, OnInit, ViewChild, OnChanges } from '@angular/core';
import { FormService } from '../../core/services/form.service';
import { ActivatedRoute } from '@angular/router';
import { Http, URLSearchParams } from '@angular/http';
import { FormArray, FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { SimpleGlobal } from 'ng2-simple-global';
import { CommonService } from '../../core/services/common.service';
import { environment } from '../../../environments/environment';
import { validateEmail } from '../../common/validators/email-validator.directive';
import { validateAllowedCharacters } from '../../common/validators/allowed-characters-validator.directive';
import { validateNumericCharacters } from '../../common/validators/numeric-validator.directive';
import { validateLength } from '../../common/validators/length-validator.directive';
import { Invite } from '../../core/models/invite.model';
import { validateState } from '../../common/validators/state-validators.directive';
import { IMultiSelectSettings } from 'angular-2-dropdown-multiselect';
import { SignaturePad } from 'angular2-signaturepad/signature-pad';


@Component({
	selector: 'app-invite-show',
	templateUrl: './invite-show.component.html',
	styleUrls: ['./invite-show.component.css']
})
export class InviteShowComponent implements OnInit, AfterViewInit, OnChanges {

	invite: Invite;
	token: string;
	verificationForm: FormGroup;
	ExtraFieldForm: FormGroup;
	public filterParams: URLSearchParams = new URLSearchParams();
	detailsSubmitted: boolean;
	employeeId: string;
	employeeName: string;
	errorOccurred: boolean;
	employment_type = 'experienced';
	canEdit: boolean = true;
	recruiter_id: number;
	showpayrollOutsourceFields: boolean = false;
	formSubmitted: boolean = false;

	maxFileSize: number = 3145728;
	maxFileError: boolean = true;

	signature: any;
	isSignatureAdded = false;

	@ViewChild(SignaturePad) signaturePad: SignaturePad;

	showEmploymentVerification = true;


	// Create a new invite data instance
	formData = new FormData();
	data = [];
	mySettings: IMultiSelectSettings = {
		enableSearch: true,
		checkedStyle: 'fontawesome',
		buttonClasses: 'multiselect-items btn btn-default',
		dynamicTitleMaxItems: 3,
		displayAllSelectedText: false,
		maxHeight: '300px',
		selectionLimit: 1,
		autoUnselect: true,
		closeOnSelect: true
	};

	files = [];

	constructor (
		private route: ActivatedRoute,
		private formService: FormService,
		private fb: FormBuilder,
		private commonService: CommonService,
		protected http: Http,
		protected el: ElementRef,
		public global: SimpleGlobal,
	) {
	}

	public inviteToken: string;

	get clientNotSimpl () {

		if (this.invite) return this.invite.id !== 556;

		return true;
	}

	ngOnInit () {

		this.route.queryParams.subscribe(params => {
			this.recruiter_id = params['recruiter_id'];
		});
		this.route.params.subscribe(params => {

			this.inviteToken = params['token'];

      //redirect to new invite form
      this.redirectToNewForm();

			this.formService.findByInviteToken(this.inviteToken).subscribe(response => {

				this.invite = response;
				this.employeeId = this.invite.employee_id;
				this.employeeName = this.invite.name;
				this.canEdit = response['active'];
				this.setExtraFileds(response);
				if (this.canEdit) {
					this.initForm();
					if (this.invite.employee_id) {
						this.populateVerificationForm(response['education_verifications'], 'education_verifications');
						this.applyEducationValidations();
						this.populateVerificationForm(response['employment_verifications'], 'employment_verifications');
						this.applyEmploymentValidations();
						this.populateVerificationForm(response['reference_verifications'], 'reference_verifications');
						this.applyReferenceValidations();
						this.populateVerificationForm(response['address_verifications'], 'address_verifications');
						this.applyAddressValidations();
						this.populateVerificationForm(response['identity_verifications'], 'identity_verifications');
					}
				} else {
					this.commonService.notifications.error('Link Expired');
				}

				this.ngOnChanges();
			});

		});

	}

  redirectToNewForm():boolean{

    if(environment.app_env == 'production'){

      window.location.href = "https://form.instaveritas.com/#/invites/"+this.inviteToken;

    }else if(environment.app_env=='staging'){

      window.location.href = "https://test-form.instaveritas.com/#/invites/"+this.inviteToken;

    }else{

      window.location.href = "http://localhost:4201/#/invites/"+this.inviteToken;

    }

    return false;
  }

	ngOnChanges () {

		if (this.ExtraFieldForm && this.ExtraFieldForm.get('employment_type')) {
			this.ExtraFieldForm.get('employment_type').valueChanges.subscribe(value => {

				if (value !== 'Fresher')
					this.showEmploymentVerification = true
				else
					this.showEmploymentVerification = false

			});
		}

	}

	initForm () {


		this.verificationForm = this.fb.group({
			'name': [this.invite.name, [Validators.required, validateAllowedCharacters('')]],
			'mobile_number': [this.invite.mobile_number, [Validators.required, validateNumericCharacters('')]],
			'alternate_number': [this.invite.alternate_number, [validateNumericCharacters('')]],
			'email': [this.invite.email, [Validators.required, validateEmail()]],
			'client_employee_id': [this.invite.client_employee_id],
			'fields': '',
			'client_id': [this.recruiter_id],
			'expected_joining_date': [this.invite.expected_joining_date],
			'identity_verifications': this.fb.array([this.initIdentityVerification()]),
			'education_verifications': this.fb.array([this.initEducationVerification()]),
			'employment_verifications': this.fb.array([this.initEmploymentVerification()]),
			'address_verifications': this.fb.array([this.initAddressVerification()]),
			'reference_verifications': this.fb.array([this.initReferenceVerification()]),
		});
	}

	setExtraFileds (response): void {

		const fields: any[] = response.fields;

		const temp: any = {};

		fields.map(field => {

			const required = field.required === '1' ? Validators.required : null;

			temp[field.key] = ['', required];
		});

		this.ExtraFieldForm = this.fb.group(temp);

	}

	/**
	 * Patch existing employee values to the form
	 *
	 * @param data
	 * @param verification
	 */
	populateVerificationForm (data, verification): void {
		this.verificationForm.patchValue(data);

		const verificationFormGroup = data.map(verification => this.fb.group(verification));

		const verificationGroupArray = this.fb.array(verificationFormGroup);

		this.verificationForm.setControl(verification, verificationGroupArray);

	}

	applyEducationValidations (): void {
		const formArray: FormArray = <FormArray> this.verificationForm.controls.education_verifications;
		formArray.controls.forEach(form => form.get('passing_year').setValidators([validateNumericCharacters(''), validateLength('4')]));
	}

	applyEmploymentValidations (): void {
		const formArray: FormArray = <FormArray> this.verificationForm.controls.employment_verifications;
		formArray.controls.forEach(form => form.get('reference_name').setValidators([Validators.required, validateAllowedCharacters('')]));
		formArray.controls.forEach(form => form.get('reference_title').setValidators([Validators.required, validateAllowedCharacters('')]));
		formArray.controls.forEach(form => form.get('reference_number').setValidators([validateNumericCharacters('')]));
		formArray.controls.forEach(form => form.get('reference_email').setValidators([validateEmail()]));
		formArray.controls.forEach(form => form.get('hr_number').setValidators([validateNumericCharacters('')]));
		formArray.controls.forEach(form => form.get('hr_email').setValidators([validateEmail()]));
	}

	applyAddressValidations (): void {

		if (this.invite.current_address_verification) {
			const formArray: FormArray = <FormArray> this.verificationForm.controls.address_verifications;
			formArray.controls[0].get('current_pincode').setValidators([validateNumericCharacters(''), validateLength('6')]);
			formArray.controls[0].get('current_state_name').setValidators([validateState(this.global['states'])]);
			formArray.controls[0].get('current_district_name').setValidators([validateState(this.global['districts'])]);
		}

		if (this.invite.permanent_address_verification) {
			const formArray: FormArray = <FormArray> this.verificationForm.controls.address_verifications;
			formArray.controls[0].get('permanent_pincode').setValidators([validateNumericCharacters(''), validateLength('6')]);
			formArray.controls[0].get('permanent_state_name').setValidators([validateState(this.global['states'])]);
			formArray.controls[0].get('permanent_district_name').setValidators([validateState(this.global['districts'])]);
		}

	}

	applyReferenceValidations (): void {
		const formArray: FormArray = <FormArray> this.verificationForm.controls.reference_verifications;
		formArray.controls.forEach(form => form.get('name').setValidators([Validators.required, validateAllowedCharacters('')]));
		formArray.controls.forEach(form => form.get('number').setValidators([validateNumericCharacters('')]));
	}

	submitDetails () {

		this.formSubmitted = true;

		this.setExtraFieldsToFormGroup();

		const url = environment.client_url + 'invites/' + this.inviteToken + '/upload-file';

		this.formService.store(this.inviteToken, this.verificationForm.value).subscribe(response => {

			const employeeId: string = response['employee_id'];

			this.formData.append('employee_id', employeeId);

			const totalFiles = this.files.length;

			let totalFilesUploaded = 0;

			this.files.forEach(file => {

				const formData = new FormData();

				formData.append("employee_id", employeeId);

				formData.append("verification", file.verification);

				formData.append("index", file.index);

				formData.append("type_of_doc", file.type_of_doc);

				formData.append("file", file.file);

				this.formService.uploadFile(url, formData).subscribe(response => {

					totalFilesUploaded++;

					if (totalFilesUploaded >= totalFiles) {

						this.detailsSubmitted = true;

						this.formSubmitted = true;

						this.commonService.notifications.success('Form Submitted');

						this.invite = null;

					}

				}, error => {

					this.commonService.notifications.error(`File Upload Failed ${ file.verification } ${ file.type_of_doc } ${ error.message }`);

					// this.formSubmitted = false;

				})

			});

		}, error => {

			this.commonService.notifications.error('Submit Failed');

			this.formSubmitted = false;

		});

	}


	onFileChange (verification, index, type_of_doc) {

		this.maxFileError = false;

		// Locate the file element meant for the file upload.
		const inputEl: HTMLInputElement = this.el.nativeElement.querySelector('#' + verification + '_' + type_of_doc + '_' + index);

		// Get the total amount of files attached to the file input.
		const fileCount: number = inputEl.files.length;

		// Check if the file count is greater than zero, to be sure a file was selected.
		if (fileCount > 0 && inputEl.files[0].size < this.maxFileSize) { // a file was selected

			if (verification === 'resume') {

				this.files.push({
					verification: verification,
					index: index,
					type_of_doc: type_of_doc,
					file: inputEl.files.item(0)
				});

				this.formData.append(verification + '_' + index + '_' + type_of_doc + '_file_' + 1, inputEl.files.item(0));

			} else {

				this.setDocumentCount(verification, type_of_doc, index);

				for (let i = 0; i < fileCount; i++) {

					this.formData.append(verification + '_' + index + '_' + type_of_doc + '_file_' + i, inputEl.files.item(i));

					this.files.push({
						verification: verification,
						index: index,
						type_of_doc: type_of_doc,
						file: inputEl.files.item(i)
					});

				}
			}

		} else {

			this.maxFileError = true;

			this.commonService.notifications.error('File size greater than 3 mb');

		}
	}

	onCustomFileChange (verification, index, type_of_doc) {

		this.maxFileError = false;

		// Locate the file element meant for the file upload.
		const inputEl: HTMLInputElement = this.el.nativeElement.querySelector('#' + verification + '_' + type_of_doc + '_' + index);

		// Get the total amount of files attached to the file input.
		const fileCount: number = inputEl.files.length;

		// Check if the file count is greater than zero, to be sure a file was selected.
		if (fileCount > 0 && inputEl.files[0].size < this.maxFileSize) { // a file was selected

			this.formData.append(verification + '_' + index + '_' + type_of_doc + '_file_' + 1, inputEl.files.item(0));

			this.files.push({
				verification: verification,
				index: index,
				type_of_doc: type_of_doc,
				file: inputEl.files.item(0)
			});

		} else {
			this.maxFileError = true;
			this.commonService.notifications.error('File size greater than 3 mb');
		}
	}

	splitStringToArray (text: string): string[] {

		return text.split(',');
	}

	arrayToString (arr: any): string {

		if (typeof arr === 'string') {
			return arr;
		}

		return arr.join(', ');
	}

	initIdentityVerification () {
		return this.fb.group({
			type_id: [''],
			type_name: [''],
			front_url: [''],
			back_url: [''],
		});
	}

	initEducationVerification () {
		return this.fb.group({
			institute_name: [''],
			college_name: [''],
			enrollment_number: [''],
			course_name: [''],
			passing_year: ['', [validateNumericCharacters(''), validateLength('4')]],
			cgpa: [''],
			discipline: [''],
			degree: [null],
			marksheet: [null],
			document: [null]
		});
	}

	initEmploymentVerification () {

		const offer_letter = this.clientNotSimpl ? [null, [Validators.required]] : [1];
		const payslip = this.clientNotSimpl ? [null, [Validators.required]] : [1];

		return this.fb.group({
			employment_company_name: [''],
			employment_type_id: [''],
			joining_date: [''],
			end_date: [''],
			designation: [''],
			department: [''],
			salary: [''],
			reference_name: ['', [Validators.required, validateAllowedCharacters('')]],
			reference_number: ['', [validateNumericCharacters('')]],
			reference_email: ['', [validateEmail()]],
			hr_name: [''],
			hr_number: ['', [validateNumericCharacters('')]],
			hr_email: ['', [validateEmail()]],
			reference_title: [''],
			document: [null],
			relieving_letter: [null],
			offer_letter: offer_letter,
			payslip: payslip,
			agency: [''],
			agency_name: [''],
			agency_address: [''],
			agency_contact: ['', [validateNumericCharacters('')]],
			employee_id: ['']
		});
	}

	initReferenceVerification () {
		return this.fb.group({
			name: ['', [Validators.required, validateAllowedCharacters('')]],
			number: ['', [validateNumericCharacters('')]],
			relation: [''],
			email: ['', [validateEmail()]],
			reference_company_name: ['', [Validators.required]],
			is_same_company_reference: ['', [Validators.required]]
		});
	}

	initAddressVerification () {


		return this.fb.group({
			current_address_line1: [''],
			current_address_line2: [''],
			current_address_line3: [''],
			current_state_id: [''],
			current_state_name: [''],
			current_district_id: [''],
			current_district_name: [''],
			current_pincode: ['', [validateNumericCharacters(''), validateLength('6')]],
			current_landmark: [''],
			current_reference_name: [''],
			current_reference_number: ['', [validateNumericCharacters('')]],
			permanent_address_line1: [''],
			permanent_address_line2: [''],
			permanent_address_line3: [''],
			permanent_state_id: [''],
			permanent_state_name: [''],
			permanent_district_id: [''],
			permanent_district_name: [''],
			permanent_pincode: ['', [validateNumericCharacters(''), validateLength('6')]],
			permanent_landmark: [''],
			permanent_reference_name: [''],
			permanent_reference_number: ['', [validateNumericCharacters('')]],
		});

	}

	/**
	 * Add new verification
	 * @param type
	 */
	addNewRow (type) {

		const control = <FormArray> this.verificationForm.controls[type];

		if (type == 'identity_verifications') {
			control.push(this.initIdentityVerification());
		}

		if (type == 'education_verifications') {
			control.push(this.initEducationVerification());
		}

		if (type == 'employment_verifications') {
			control.push(this.initEmploymentVerification());
		}

		if (type == 'reference_verifications') {
			control.push(this.initReferenceVerification());
		}

	}

	deleteRow (type, index: number) {

		const control = <FormArray> this.verificationForm.controls[type];

		control.removeAt(index);
	}


	// Set the value of the invite control state_id
	OnStateSelect (event, type) {

		let state = type + '_state_id';
		let district = type + '_district_id';

		const formArray: FormArray = <FormArray> this.verificationForm.controls.address_verifications;

		formArray.controls[0].get(state).setValue(event[0]);

		// Setting the default value on any change is selection of state.
		formArray.controls[0].get(district).setValue('');
	}

	// Set the value of the invite control district_id
	OnDistrictSelect (event, type) {
		let district = type + '_district_id';

		const formArray: FormArray = <FormArray> this.verificationForm.controls.address_verifications;

		formArray.controls[0].get(district).setValue(event[0]);
	}

	onTypeOfDocChange (verification, index) {
		if (verification == 'identity_verifications') {
			const formArray: FormArray = <FormArray> this.verificationForm.controls.identity_verifications;
			formArray.controls[index].get('front_url').setValue(null);
			formArray.controls[index].get('back_url').setValue(null);
		}
	}

	setDocumentCount (verification: any, type_of_doc: any, index: any) {
		const formArray: FormArray = <FormArray> this.verificationForm.controls[verification];
		formArray.controls[index].get(type_of_doc).setValue(1);
	}

	setMaxFileError (value: boolean) {
		this.maxFileError = value;
	}

	private signaturePadOptions: Object = { // passed through to szimek/signature_pad constructor
		'minWidth': 0.5,
		'canvasWidth': 300,
		'canvasHeight': 200,
		'backgroundColor': 'rgb(211,211,211)'
	};

	ngAfterViewInit () {
		// this.signaturePad is now available
		if (this.signaturePad) {
			this.signaturePad.set('minWidth', 5); // set szimek/signature_pad options at runtime
			this.signaturePad.clear(); // invoke functions from szimek/signature_pad API
		}
	}

	drawComplete () {
		// will be notified of szimek/signature_pad's onEnd event
		// console.log(this.signaturePad.toDataURL());
	}

	drawStart () {
		// will be notified of szimek/signature_pad's onBegin event
		// console.log('begin drawing');
	}

	clear () {
		this.signaturePad.clear();
		this.isSignatureAdded = false;
	}

	save () {
		if (this.signaturePad.isEmpty()) {
			return alert('Please provide a signature first.');
		}

		this.signature = this.b64toBlob(this.signaturePad.toDataURL());

		this.formData.append('signature', this.signature);

		this.files.push({
			verification: 'employee',
			index: 0,
			type_of_doc: 'signature',
			file: this.signature
		});

		this.isSignatureAdded = true;

		this.commonService.notifications.success('Signature saved successfully');
	}

	b64toBlob (dataURI) {

		var byteString = atob(dataURI.split(',')[1]);
		var ab = new ArrayBuffer(byteString.length);
		var ia = new Uint8Array(ab);

		for (var i = 0; i < byteString.length; i++) {
			ia[i] = byteString.charCodeAt(i);
		}
		return new Blob([ab], { type: 'image/png' });
	}

	showPayrollFields (value, j) {

		const formArray = <FormArray> this.verificationForm.controls.employment_verifications;

		if (value == 1) {
			this.showpayrollOutsourceFields = true;
			formArray.controls[j].get('agency_name').setValidators([Validators.required]);
			formArray.controls[j].get('agency_address').setValidators([Validators.required]);
			formArray.controls[j].get('agency_contact').setValidators([Validators.required, validateNumericCharacters('')]);
		} else {
			this.showpayrollOutsourceFields = false;
			formArray.controls[j].get('agency_name').setValidators([]);
			formArray.controls[j].get('agency_address').setValidators([]);
			formArray.controls[j].get('agency_contact').setValidators([]);
		}

		formArray.controls[j].get('agency_name').updateValueAndValidity();
		formArray.controls[j].get('agency_address').updateValueAndValidity();
		formArray.controls[j].get('agency_contact').updateValueAndValidity();
	}

	populateCurrentAddress (event) {

		const formArray = <FormArray> this.verificationForm.controls.address_verifications;

		if (event.target.checked) {
			formArray.controls[0].get('current_address_line1').setValue(formArray.controls[0].get('permanent_address_line1').value);
			formArray.controls[0].get('current_address_line2').setValue(formArray.controls[0].get('permanent_address_line2').value);
			formArray.controls[0].get('current_address_line3').setValue(formArray.controls[0].get('permanent_address_line3').value);
			formArray.controls[0].get('current_state_id').setValue(formArray.controls[0].get('permanent_state_id').value);
			formArray.controls[0].get('current_state_name').setValue(formArray.controls[0].get('permanent_state_name').value);
			formArray.controls[0].get('current_district_id').setValue(formArray.controls[0].get('permanent_district_id').value);
			formArray.controls[0].get('current_district_name').setValue(formArray.controls[0].get('permanent_district_name').value);
			formArray.controls[0].get('current_pincode').setValue(formArray.controls[0].get('permanent_pincode').value);
			formArray.controls[0].get('current_landmark').setValue(formArray.controls[0].get('permanent_landmark').value);
			formArray.controls[0].get('current_reference_name').setValue(formArray.controls[0].get('permanent_reference_name').value);
			formArray.controls[0].get('current_reference_number').setValue(formArray.controls[0].get('permanent_reference_number').value);
		} else {
			formArray.controls[0].get('current_address_line1').setValue('');
			formArray.controls[0].get('current_address_line2').setValue('');
			formArray.controls[0].get('current_address_line3').setValue('');
			formArray.controls[0].get('current_state_id').setValue('');
			formArray.controls[0].get('current_state_name').setValue('');
			formArray.controls[0].get('current_district_id').setValue('');
			formArray.controls[0].get('current_district_name').setValue('');
			formArray.controls[0].get('current_pincode').setValue('');
			formArray.controls[0].get('current_landmark').setValue('');
			formArray.controls[0].get('current_reference_name').setValue('');
			formArray.controls[0].get('current_reference_number').setValue('');
		}
	}

	checkSignature (): boolean {

		if (this.invite.form_settings) {

			if (this.invite.form_settings.signature === '1') {

				return true;
			}

			this.isSignatureAdded = true;

			return false;
		}

		return true;
	}

	removeValidation (field) {

		field.setValidators([]);
		field.updateValueAndValidity();
	}

	showBackUpload(docType): boolean {

		// voter aadhaar licence passport
		return docType == 1 || docType == 3 || docType == 4 || docType == 5;

	}

	private setExtraFieldsToFormGroup () {

		this.verificationForm.get('fields').setValue(this.ExtraFieldForm.value);
	}

}



// WEBPACK FOOTER //
// /home/forge/dev-client-app.instaveritas.com/releases/20231127121751/src/app/form/invite-show/invite-show.component.ts